// Caché del catálogo de productos (nombre/foto/precio) en sessionStorage: se
// pide una sola vez por sesión de pestaña (no cambia seguido); se vuelve a
// pedir si el usuario cierra y reabre el sistema (nueva pestaña/sesión), si
// se fuerza el refresco desde Registrar, o si se limpia por un cambio de
// precios (ver PreciosImportar.jsx) para no dejar precios viejos en pantalla.
const PRODUCTOS_CACHE_KEY = 'agilia_productos_cache_v1';

export const leerProductosCache = () => {
  try {
    const raw = sessionStorage.getItem(PRODUCTOS_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const guardarProductosCache = (productos) => {
  try { sessionStorage.setItem(PRODUCTOS_CACHE_KEY, JSON.stringify(productos)); } catch { /* storage lleno o bloqueado: seguimos sin cache */ }
};

export const limpiarProductosCache = () => {
  try { sessionStorage.removeItem(PRODUCTOS_CACHE_KEY); } catch { /* nada que limpiar */ }
};
